import { Dialog, Transition } from "@headlessui/react";
import html2canvas from "html2canvas";
import moment from "moment";
import { Fragment, useEffect, useRef, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-spring-bottom-sheet/dist/style.css";
import { toast } from "react-toastify";
import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import paymentSuccess from "../../assets/images/icon_invoice/payment-success.svg";
import { isDarkColor } from "../../config/DarkColorChecker";
import { formatCurrency } from "../../config/global";
import { setLoading } from "../../core/feature/config/configSlice";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import { invoicePayment } from "../../core/service/api_invoice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import { StatsInvoice } from "../common/home/Stats";

const ComponentInvoiceCreditPayment = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp,
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any>({});
  const [amount, setAmount] = useState<any>(0);
  const user: User = useAppSelector((state) => state.user.user);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const nominalList = [100000, 200000, 300000, 500000];
  const balance = localStorage.getItem("balance_redux");
  const location = useLocation();
  const detail = location.state?.data.detail;
  const invoiceId = location.state?.data.invoiceId;
  const [minimumPayment, setMinimumPayment] = useState<any>(0);
  const minimumPaymentType = location.state?.data.minimumPaymentType;
  const minimumPaymentPosition = location.state?.data.minimumPaymentPosition;
  const unpaidAmount =
    location.state?.data.detail.reduce(
      (acc: number, curr: any) =>
        acc + (curr.amount || 0) - (curr.discount || 0),
      0,
    ) - location.state?.data.paidAmount;
  const [openPaymentSuccessInvoice, setOpenPaymentSuccessInvoice] =
    useState(false);
  const [detailPaymentSuccess, setDetailPaymentSuccess] = useState<any>([]);
  const [tempPaymentList, setTempPaymentList] = useState<any>([]);
  const [totalPayment, setTotalPayment] = useState<any>(0);
  const [tempAmount, setTempAmount] = useState<any>(0);
  const [invoiceToPay, setInvoiceToPay] = useState<any>({});
  const [mustPaidOff, setMustPaidOff] = useState(false);
  const invoiceFeature = JSON.parse(localStorage.getItem("invoice-feature")!);

  var cash = `${t("INVOICE.cash")}`;
  let [isOpen, setIsOpen] = useState(false);
  let [isOpen2, setIsOpen2] = useState(false);
  const id = useParams();

  const shareButton = useRef<HTMLButtonElement>(null);

  const closeCreate = () => {
    setIsOpen(false);
  };

  const closeCreate2 = () => {
    setIsOpen2(false);
  };

  function onDismissPaymentSuccessInvoice() {
    window.scrollTo(0, 0);
    setOpenPaymentSuccessInvoice(false);
    navigate("/invoice");
  }

  const [image, setImage] = useState();
  const downloadForm = async () => {
    const input: any = document.getElementById("DetailPay");
    if (!input) {
      toast.error("Element to download not found.");
      return;
    }
    html2canvas(input, { logging: true, useCORS: true }).then(
      (canvas: HTMLCanvasElement) => {
        const url: any = canvas.toDataURL();
        setImage(url);
        const linkSource = url;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download =
          detailPaymentSuccess?.inquiryResponseDto?.title +
          " - " +
          detailPaymentSuccess?.inquiryResponseDto?.customerName;
        downloadLink.click();
      },
    );
  };

  const handleToggle = (item: any) => {
    const isSelected = selectedItems.find((i: any) => i.title === item.title);
    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((i: any) => i.title !== item.title),
      );
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const handleSubmit = () => {
    const invoiceCredits = tempPaymentList.map((prop: any) => {
      return {
        id: prop.id,
        title: prop.title,
        amount: parseInt(prop.amount),
        coaCode: prop.coaCode,
      };
    });

    let data = {
      invoiceId: invoiceId,
      amount: parseInt(totalPayment),
      channel: "MOBILE",
      cash: false,
      invoiceCredits: invoiceCredits,
    };

    dispatch(setLoading(true));
    invoicePayment(data)
      .then((res: any) => {
        setDetailPaymentSuccess(res.data);
        setOpenPaymentSuccessInvoice(true);
        dispatch(setLoading(false));
        setIsOpen2(false);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    let minPayment = location.state?.data.minimumPayment;
    if (minimumPaymentType === "PERCENT") {
      let amount = invoiceToPay.amount;
      if (minimumPaymentPosition === "SUMMARY")
        amount = detail.reduce(
          (acc: number, curr: any) => acc + (curr.amount || 0),
          0,
        );
      minPayment = (minPayment / 100) * amount;
    }
    setMinimumPayment(minPayment);
  }, [isOpen]);

  useEffect(() => {
    setTotalPayment(
      tempPaymentList.reduce(
        (acc: number, curr: any) => acc + (curr.amount || 0),
        0,
      ),
    );
  }, [tempPaymentList]);

  useEffect(() => {
    let { minimumPayment, amount, paidAmount } = location.state?.data;
    if (minimumPaymentPosition === "SUMMARY") {
      let totalPayment = 0;
      if (amount - paidAmount < minimumPayment) {
        setTempPaymentList(
          detail.map((item: any) => {
            totalPayment += item.amount - item.discount - item.paidAmount;
            return {
              ...item,
              amount: item.amount - item.discount - item.paidAmount,
            };
          }),
        );
        setTempAmount(totalPayment);
        setMustPaidOff(true);
      }
    }
  }, []);

  return (
    <div className="bg-psp-primary pb-20 font-montserrat">
      <StatsInvoice />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        {/* <div className="px-3 pt-4 pb-3  sticky top-0">
        <TabsMobile
          name={`${t("INVOICE.creditTitle")}`}
          backUrl={"home"}
        ></TabsMobile>
      </div> */}

        {/* ====================== SUCCESS POPUP ===================== */}
        <Transition appear show={openPaymentSuccessInvoice} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={onDismissPaymentSuccessInvoice}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>
            <div className="fixed inset-0 flex items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-8 text-left align-middle shadow-xl transition-all">
                  <div id="DetailPay" className="flex flex-row gap-8">
                    {/* Left Side: Payment Success Info */}
                    <div className="flex flex-col items-center gap-2 w-1/2 border-r pr-6">
                      <img
                        src={paymentSuccess}
                        alt="success"
                        className="w-24 h-24 mb-2"
                      />
                      <h2 className="text-2xl font-semibold text-center mb-1">
                        Pembayaran Berhasil
                      </h2>
                      <div className="text-gray-500 text-sm mb-2 text-center">
                        Tanggal{" "}
                        {moment(detailPaymentSuccess.dateTime).format("LL")}{" "}
                        <br />
                        {moment(detailPaymentSuccess.dateTime).format("HH:mm")}
                      </div>
                      <div className="text-gray-400 text-xs mb-1">
                        Sisa Tagihan
                      </div>
                      <div className="text-3xl font-bold text-red mb-4">
                        {formatCurrency(
                          detailPaymentSuccess?.inquiryResponseDto?.amount -
                            detailPaymentSuccess?.inquiryResponseDto
                              ?.paidAmount,
                        )}
                      </div>
                      <div className="flex justify-between w-full mb-2">
                        <div className="flex flex-col items-center flex-1">
                          <div className="text-xs text-gray-500">Terbayar</div>
                          <div className="font-semibold text-base">
                            {formatCurrency(
                              detailPaymentSuccess?.inquiryResponseDto
                                ?.paidAmount,
                            )}
                          </div>
                        </div>
                        <div className="border-l border-gray-200 h-8 mx-4" />
                        <div className="flex flex-col items-center flex-1">
                          <div className="text-xs text-gray-500">
                            Nominal Pembayaran
                          </div>
                          <div className="font-semibold text-base">
                            {formatCurrency(detailPaymentSuccess?.amount)}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Right Side: Detail Info */}
                    <div className="flex-1 flex flex-col gap-2">
                      <div className="font-semibold mb-1 text-lg">
                        Data Pembayaran
                      </div>
                      <div>
                        <div className="flex justify-between items-center mb-2">
                          <div className=" w-1/2">Nama Orang Tua</div>
                          <div className="w-1/2 text-right">{user.name}</div>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <div className="w-1/2">Nama Siswa</div>
                          <div className="w-1/2 text-right">
                            {
                              detailPaymentSuccess?.inquiryResponseDto
                                ?.customerName
                            }
                          </div>
                        </div>
                      </div>
                      <div className="font-semibold mb-1 text-lg">
                        Detail Tagihan
                      </div>
                      <div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Nama Tagihan</span>
                          <span className="font-normal">
                            {detailPaymentSuccess?.inquiryResponseDto?.title}
                          </span>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Tgl Tagihan</span>
                          <span className="font-normal">
                            {moment(
                              detailPaymentSuccess?.inquiryResponseDto
                                ?.invoiceDate,
                            ).format("LL")}
                          </span>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Jatuh Tempo</span>
                          <span className="font-normal">
                            {moment(
                              detailPaymentSuccess?.inquiryResponseDto?.dueDate,
                            ).format("LL")}
                          </span>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Tipe Tagihan</span>
                          <span className="font-normal">
                            {detailPaymentSuccess?.inquiryResponseDto
                              ?.partialMethod === false
                              ? cash
                              : t("INVOICE.credit")}
                          </span>
                        </div>
                      </div>
                      <div className="font-semibold mb-1 text-lg">Rincian</div>
                      {detail?.map((item: any, index: any) => {
                        return (
                          <div key={index}>
                            <div className="flex justify-between items-center mb-2">
                              <span>{item.title}</span>
                              <div className="flex flex-col grow text-right">
                                {item.discount > 0 && (
                                  <span className="text-xs line-through">
                                    {formatCurrency(
                                      item.amount - item.discount,
                                    )}
                                  </span>
                                )}
                                <span className="font-normal">
                                  {formatCurrency(item.amount - item.discount)}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex flex-row gap-2 z-[1000] justify-end mt-6">
                    <button
                      onClick={downloadForm}
                      style={{ backgroundColor: customApp?.app_accent_color }}
                      className={`disabled:bg-psp-gray w-36 shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                    >
                      {t("INVOICE.download")}
                    </button>
                    <button
                      onClick={() => onDismissPaymentSuccessInvoice()}
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`disabled:bg-psp-gray w-36 shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                        isDarkColor(customApp.app_secondary_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                    >
                      {t("OTHER.close")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
        {/* ========================================================== */}

        {/* ====================== INPUT AMOUNT POPUP ===================== */}
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeCreate}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("INVOICE.inputAmount")}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-xs text-gray-500 mb-0">
                        {t("INVOICE.detailInvoice")}:
                      </p>
                      <div className="mt-0">
                        <span className="font-montserrat m-0 text-xs font-normal ">
                          {tempPaymentList.length > 0
                            ? tempPaymentList[tempPaymentList.length - 1]?.title
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="mt-2">
                      <p className="text-xs text-gray-500 mb-0">
                        {t("INVOICE.amountLabel")}:
                      </p>

                      <div className="mt-0">
                        {invoiceToPay.discount > 0 && (
                          <span className="font-montserrat m-0 mr-1 text-[10px] font-normal line-through">
                            {formatCurrency(invoiceToPay.amount)}
                          </span>
                        )}
                        <span className="font-montserrat m-0 text-xs font-normal text-red">
                          {formatCurrency(
                            invoiceToPay.amount -
                              invoiceToPay.discount -
                              invoiceToPay.paidAmount,
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="mt-2">
                      <div className="text-center mt-2 flex items-center justify-center">
                        <CurrencyInput
                          placeholder={`>= ${
                            location.state?.data.minimumPayment === 0
                              ? 10000
                              : minimumPaymentPosition === "ITEM"
                                ? minimumPayment
                                : 0
                          }`}
                          decimalsLimit={2}
                          prefix={"Rp "}
                          className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
                          value={
                            tempPaymentList.length > 0
                              ? tempPaymentList[tempPaymentList.length - 1]
                                  ?.amount || ""
                              : ""
                          }
                          onValueChange={(value) => {
                            // Update amount for the last item in tempPaymentList
                            setTempPaymentList((prev: any) => {
                              if (prev.length === 0) return prev;
                              const updated = [...prev];
                              updated[updated.length - 1] = {
                                ...updated[updated.length - 1],
                                amount: parseInt(value || "0"),
                              };
                              return updated;
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="justify-center mt-4 flex gap-2">
                      <button
                        type="button"
                        style={{
                          backgroundColor:
                            customApp?.app_secondary_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                          isDarkColor(customApp.app_secondary_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                        onClick={() => {
                          console.log(tempPaymentList);

                          // Remove the last item from tempPaymentList
                          setTempPaymentList((prev: any) => prev.slice(0, -1));
                          closeCreate();
                        }}
                      >
                        {t("TOPUP.cancel")}
                      </button>
                      <button
                        type="button"
                        style={{
                          backgroundColor: customApp?.app_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                        disabled={
                          tempPaymentList.length === 0 ||
                          parseInt(
                            tempPaymentList[tempPaymentList.length - 1]
                              ?.amount || 0,
                          ) <= 0
                        }
                        onClick={() => {
                          const amount = parseInt(
                            tempPaymentList[tempPaymentList.length - 1]
                              ?.amount || 0,
                          );
                          if (
                            minimumPaymentPosition === "SUMMARY" &&
                            location.state?.data.minimumPayment == 0 &&
                            totalPayment < 10000
                          ) {
                            alert(
                              `Amount must be at least ${formatCurrency(10000)}`,
                            );
                            return;
                          }
                          if (
                            minimumPaymentPosition === "ITEM" &&
                            amount < minimumPayment
                          ) {
                            alert(
                              `Amount must be at least ${formatCurrency(
                                minimumPayment,
                              )}`,
                            );
                            return;
                          }
                          if (
                            amount >
                            invoiceToPay.amount -
                              invoiceToPay.discount -
                              invoiceToPay.paidAmount
                          ) {
                            alert(
                              `Amount cannot be greater than the unpaid amount (${formatCurrency(
                                invoiceToPay.amount -
                                  invoiceToPay.discount -
                                  invoiceToPay.paidAmount,
                              )})`,
                            );
                            return;
                          }
                          closeCreate();
                        }}
                      >
                        {t("OTHER.save")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        {/* ================================================================ */}

        {/* ====================== CONFIRMATION POPUP ===================== */}
        <Transition appear show={isOpen2} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeCreate2}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("LOGIN.confirm")}
                    </Dialog.Title>
                    <div>
                      <p className="text-sm text-gray-500 mt-2">
                        Apakah anda yakin ingin membayar tagihan ini?{" "}
                        {`(${formatCurrency(totalPayment)})`}
                      </p>
                    </div>
                    <div className="justify-center mt-4 flex gap-2">
                      <button
                        type="button"
                        style={{
                          backgroundColor:
                            customApp?.app_secondary_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                          isDarkColor(customApp.app_secondary_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                        onClick={() => closeCreate2()}
                      >
                        {t("OTHER.no")}
                      </button>
                      <button
                        type="button"
                        style={{
                          backgroundColor: customApp?.app_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                        onClick={() => handleSubmit()}
                      >
                        {t("OTHER.yes")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        {/* ================================================================ */}

        <div className="relative z-100 z-30 mb-4 mt-4 mx-4">
          <div className="rounded-2xl w-full bg-white flex flex-row p-3 justify-between shadow-psp-primary">
            <div className="flex flex-col">
              <h1 className="font-montserrat m-0 text-xs font-medium text-black text-start">
                {t("HOME.balance")}
              </h1>
              <p className="font-montserrat m-0 text-xl font-bold text-black text-start">
                {formatCurrency(balance)}
              </p>
            </div>
            <img src={dotBalance} alt="" />
          </div>
        </div>

        <div className="p-1 bg-white mt-2 mx-2 rounded-lg overflow-y-auto">
          <div className="text-left mb-2">
            <span className="font-montserrat m-0 text-sm font-normal text-psp-nav">
              Pilih Tagihan yang ingin anda bayar
            </span>
          </div>
          {detail?.map((item: any) => (
            <div
              key={item.title}
              className={`font-montserrat w-full flex flex-col gap-4 p-2 shadow-md justify-between rounded-lg mb-2 ${
                tempPaymentList.find((i: any) => i.title === item.title)
                  ? "bg-blue-50 border-blue-400"
                  : "border-gray-300"
              }`}
            >
              <div className="flex items-center gap-2">
                <input
                  disabled={
                    item.amount - item.discount - item.paidAmount === 0 ||
                    mustPaidOff
                  }
                  type="checkbox"
                  checked={
                    !!tempPaymentList.find(
                      (i: any) => i.title === item.title,
                    ) &&
                    tempPaymentList.find((i: any) => i.title === item.title)
                      ?.amount > 0
                  }
                  onChange={(e) => {
                    setInvoiceToPay(item);
                    setTempAmount(item.amount);
                    setTempPaymentList((prev: any) => {
                      const unpaidAmount =
                        item.amount - item.discount - (item.paidAmount || 0);
                      let minpay = minimumPayment;
                      if (minimumPaymentPosition === "ITEM") {
                        if (minimumPaymentType === "PERCENT")
                          minpay =
                            (location.state?.data.minimumPayment / 100) *
                            item.amount;
                        else if (minimumPaymentType === "CURRENCY")
                          minpay = location.state?.data.minimumPayment;
                      }
                      if (prev.some((i: any) => i.title === item.title)) {
                        // Remove item if already exists
                        return prev.filter((i: any) => i.title !== item.title);
                      } else {
                        if (
                          unpaidAmount < minpay &&
                          minimumPaymentPosition === "ITEM"
                        ) {
                          // Just add item with unpaidAmount, no popup, don't set amount to 0
                          return [
                            ...prev,
                            {
                              ...item,
                              amount: unpaidAmount,
                            },
                          ];
                        } else {
                          setIsOpen(true);
                          // Add item with amount 0, will be set in popup
                          return [
                            ...prev,
                            {
                              ...item,
                              amount: 0,
                            },
                          ];
                        }
                      }
                    });
                    // });
                  }}
                  className="w-5 h-5 text-blue-600"
                />
                <div className="font-montserrat m-0 text-xs font-bold text-black inline ml-2">
                  {item.title}
                </div>
              </div>

              <div className="flex flex-col gap-1 w-full">
                <div className="flex justify-between w-full">
                  <span className="text-xs">Nominal Tagihan</span>
                  <span className=" text-xs">
                    {formatCurrency(item.amount)}
                  </span>
                </div>
                <div className="flex justify-between w-full">
                  <span className="text-xs">Diskon</span>
                  <span className=" text-red text-xs">
                    {formatCurrency(item.discount)}
                  </span>
                </div>
                <div className="flex justify-between w-full">
                  <span className="text-xs">Total Tagihan</span>
                  <span className="text-red text-xs">
                    {formatCurrency(item.amount - item.discount)}
                  </span>
                </div>
                <div className="flex justify-between w-full  border-t border-psp-gray pt-2">
                  <span className="text-xs">Tagihan Terbayar</span>
                  <span className=" text-red text-xs">
                    {formatCurrency(item.paidAmount)}
                  </span>
                </div>
                <div className="flex justify-between w-full border-b border-psp-gray pb-2">
                  <span className="text-xs">Sisa Tagihan</span>
                  <span className="font-bold text-red text-xs">
                    {formatCurrency(
                      item.amount - item.discount - item.paidAmount,
                    )}
                  </span>
                </div>
                <div className="flex justify-between w-full">
                  <span className="text-xs">Nominal yang akan dibayar</span>
                  <span className="text-xs">
                    {formatCurrency(
                      tempPaymentList.find((i: any) => i.title === item.title)
                        ?.amount,
                    )}
                  </span>
                </div>
              </div>
            </div>
          ))}
          <div className="flex justify-between items-center mt-4 border-t pt-3">
            <span className="font-montserrat m-0 text-sm font-normal text-psp-nav">
              Total Payment
            </span>
            <span className="font-montserrat text-sm font-normal text-psp-primary">
              {formatCurrency(
                tempPaymentList.reduce(
                  (acc: number, curr: any) => acc + (curr.amount || 0),
                  0,
                ),
              )}
            </span>
          </div>
        </div>
        <div className="p-3 w-36 flex justify-end ml-auto">
          <button
            onClick={() => {
              if (minimumPaymentPosition === "SUMMARY") {
                if (
                  totalPayment < minimumPayment &&
                  minimumPayment <= unpaidAmount
                ) {
                  alert(
                    `Total payment must be at least ${formatCurrency(
                      minimumPayment,
                    )}`,
                  );
                  return;
                }
                if (
                  totalPayment < minimumPayment &&
                  totalPayment < unpaidAmount
                ) {
                  alert(
                    `Total payment must be at least ${formatCurrency(
                      unpaidAmount,
                    )}`,
                  );
                  return;
                }
                if (
                  location.state?.data.minimumPayment === 0 &&
                  totalPayment < 10000
                ) {
                  alert(
                    `Total payment must be at least ${formatCurrency(10000)}`,
                  );
                  return;
                }
              }
              setIsOpen2(true);
            }}
            style={{
              backgroundColor: customApp?.app_accent_color,
              width: "100%",
            }}
            className={`px-2 py-2.5 rounded-lg font-bold text-xs active:bg-psp-active block w-full ${
              isDarkColor(customApp.app_accent_color)
                ? "text-white"
                : "text-black"
            }`}
          >
            {t("INVOICE.pay")}
          </button>
        </div>
      </div>
    </div>
  );
};
export default ComponentInvoiceCreditPayment;
